import script from "./TransactionsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionsView.vue?vue&type=script&setup=true&lang=js"

import "./TransactionsView.vue?vue&type=style&index=0&id=8fcfb8ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fcfb8ae"]])

export default __exports__